import $ from 'cash-dom';

$(function () {
	const $elToShowHide = $('.show-hide-on-visible-position');

	showHideIfNeeded();

	window.addEventListener('scroll', function () {
		showHideIfNeeded();
	});

	function showHideIfNeeded() {
		$('.right-col.bottom-line-holder .expert-bottom-line').each(function (i) {
			if (this.getBoundingClientRect().bottom < 102) {
				$elToShowHide.show();
			} else {
				$elToShowHide.hide();
			}
		});
	}
});
